import React from "react";
import { Upload, Button, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";

const UploadComponent = ({ accept, onChange, id, fileList, style }) => {
  const filteredFileList = fileList.filter((element) => element.id == id);

  return (
    <Upload
      id={id}
      beforeUpload={(file) => {
        return false;
      }}
      accept={accept}
      onChange={(file) => onChange(file, id)}
      fileList={filteredFileList}
    >
      <Button
        className={"upload-btn"}
        style={{ borderColor: style, color: style }}
      >
        <UploadOutlined /> Odaberite datoteku
      </Button>
    </Upload>
  );
};

export default UploadComponent;
